// extracted by mini-css-extract-plugin
module.exports = {"errorDialog":"ErrorDialog_errorDialog__2TZrU"};